import React from 'react';
import './style.css'

const Scrollbar = () => {

    return(
        <div className="col-lg-12">
            <div className="header-menu">
                <ul className="smothscroll">
                    <li><a href='https://wa.me/message/UTB4XLJQLZ22M1' target="_blank" rel="noopener noreferrer"><i className="fa fa-whatsapp"></i></a></li>
                </ul>
            </div>
        </div>
        
    )
}

export default Scrollbar;
